import { FC } from "react";

import { useTranslation } from "react-i18next";

import { Draft } from "@utils/Draft.util";
import { InputProps } from "@utils/InputProps.util";
import { NumberInput, Select } from "@mantine/core";

import { IPhoneNumber } from "@models/PhoneNumber";

import COUNTRY_CODES from "./jsons/COUNTRY_CODES.json";

export const PhoneNumberInput: FC<
  InputProps<Draft<IPhoneNumber>> & { required?: boolean }
> = ({ code, number, required = true }) => {
  const { t } = useTranslation();
  const { onChange, ...rest } = number || {};
  return (
    <NumberInput
      required={required}
      label={t("Phone Number")}
      styles={(t) => ({
        input: {
          paddingLeft: 100 + t.spacing.sm,
          paddingRight: t.spacing.sm,
        },
        rightSection: {
          left: 0,
        },
      })}
      rightSection={
        <Select
          searchable
          required={required}
          data={COUNTRY_CODES.map((cc) => ({
            value: cc.code,
            label: cc.dial_code,
          }))}
          styles={{
            input: {
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
            },
          }}
          {...code}
        />
      }
      rightSectionWidth={100}
      {...rest}
      onChange={(ev) => {
        onChange(ev || null);
      }}
    />
  );
};
